import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Ispettorato } from '../models/ispettorato';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class IspettoratoService extends ResourcefulService<Ispettorato>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Ispettorato);
    }
}
